/* Klaviyo star rating labels. The snippet custom.product-rating is rendered once per product card, so this file
   can be included many times on one page – guard + closure keep it to a single MutationObserver and avoid
   "Identifier 'observer' has already been declared" on repeated loads. */
(() => {
  if (window.__evoProductRatingInit) return;
  window.__evoProductRatingInit = true;

  function parseReviewCount(text) {
    if (!text) return 0;
    const digits = String(text).replace(/[^\d]/g, '');
    return digits ? Number(digits) : 0;
  }

  function formatReviewCount(count, locale) {
    return Number(count).toLocaleString(locale);
  }

  function applyKlaviyoRatingLabel(widget) {
    const label = widget.querySelector('.kl_reviews__star_rating_widget__label');
    const isPdp = widget.dataset.placement === 'pdp' || Boolean(widget.closest('.product-info__klaviyo-rating'));

    if (isPdp) {
      const row = widget.closest('.product-info__klaviyo-rating');
      if (!row) return;

      const labelCount = parseReviewCount(label && label.textContent);
      const count = Number(widget.dataset.ratingCount) || labelCount;
      const rating = widget.dataset.ratingValue;
      const locale = widget.dataset.locale || document.documentElement.lang || 'en';
      const valueEl = row.querySelector('[data-klaviyo-rating-value]');
      const fromEl = row.querySelector('[data-klaviyo-rating-from]');
      const template = widget.dataset.fromTemplate || 'from __COUNT__ Reviews';

      if (valueEl && rating !== '' && rating != null) {
        const numericRating = Number(rating);
        if (!Number.isNaN(numericRating) && numericRating > 0) {
          valueEl.textContent = numericRating.toLocaleString(locale, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          });
          valueEl.hidden = false;
          const sepEl = row.querySelector('.product-info__klaviyo-rating-sep');
          if (sepEl) sepEl.hidden = false;
        }
      }

      if (fromEl && count > 0) {
        fromEl.textContent = template.replaceAll('__COUNT__', formatReviewCount(count, locale));
      }

      if (label) label.hidden = true;
      row.hidden = count < 1 && !rating;
      return;
    }

    if (!label) return;
    // Already formatted – re-parsing "4,7 (306)" would read 47306
    if (label.dataset.evoFormatted && label.dataset.evoFormatted === label.textContent) return;

    const count = parseReviewCount(label.textContent);
    if (!count) return;

    let text = `(${count})`;

    // Collection grid shows the average in front of the count: "4,7 (306)"
    if (widget.closest('.evo-collection')) {
      const ariaLabel = widget.querySelector('[aria-label]')?.getAttribute('aria-label') || '';
      const match = ariaLabel.match(/\d+(?:[.,]\d+)?/);
      const rating = match ? Number(match[0].replace(',', '.')) : NaN;
      if (!Number.isNaN(rating) && rating > 0) {
        const locale = document.documentElement.lang || 'de';
        text = `${rating.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} ${text}`;
      }
    }

    label.textContent = text;
    label.dataset.evoFormatted = text;
  }

  function refreshKlaviyoRatingLabels() {
    document.querySelectorAll('.klaviyo-star-rating-widget').forEach(applyKlaviyoRatingLabel);
  }

  const observer = new MutationObserver(function () {
    observer.disconnect();
    refreshKlaviyoRatingLabels();
    observer.observe(document.body, { childList: true, subtree: true });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  refreshKlaviyoRatingLabels();
})();
